import { api } from '@/core/api/';
const apiUrl = 'api/dashboard';

export const getTypes = (payload) => {
  return api.get(`${apiUrl}/scheduleitemtypes`, {
    params: { ...payload },
  });
};

export const getAllPosts = (payload) => {
  return api.get(`${apiUrl}`, {
    params: { ...payload },
  });
};

export const changePostStatus = (postId, newStatus) => {
  return api.patch(`${apiUrl}/changestatus/${postId}`, newStatus);
};

export const getWorkshopStatuses = () => {
  return api.get(`${apiUrl}/workshop/statuses`);
};

export const getAllWorkshop = (params) => {
  return api.get(`${apiUrl}/workshops`, { params });
};

export const getWorkshopDetail = (workshopId) => {
  return api.get(`${apiUrl}/workshop/${workshopId}`);
};

export const getLatestParticipant = () => {
  return api.get(`${apiUrl}/workshop/participant/lastRegistered`);
};

export const addWorkshopParticipant = (payload) => {
  return api.post(`${apiUrl}/addparticipant`, payload);
};

export const updateParticipantWorkshopStatus = (payload) => {
  return api.patch(`${apiUrl}/update/participant`, payload);
};

export const redeemWorkshop = (payload) => {
  return api.post(`${apiUrl}/workshop/redeem`, payload);
};

export const getCards = (moduleId) => {
  return api.get(`${apiUrl}/cards/${moduleId}`);
};

export const getModules = (appId) => {
  return api.get(`${apiUrl}/modules/${appId}`);
};

export const getAllWorkshopParticipants = (params) => {
  return api.get(`${apiUrl}/workshop/participants/search`, { params });
};
export const getVideos = (payload) => {
  return api.get(`${apiUrl}/videos`, {
    params: { ...payload },
  });
};

export const getGuides = (payload) => {
  return api.get(`${apiUrl}/userguides`, {
    params: { ...payload },
  });
};

export const getApplications = () => api.get(`${apiUrl}/application`);

export const downloadWorkshopCertificate = async (id) => {
  const { data } = await api.get(`${apiUrl}/workshopcertificate/${id}`);

  download(data);
};

export const validateWorkshopTests = (id) => {
  return api.get(`${apiUrl}/workshop/validatetests?dashboardpostid=${id}`);
};

export const getDocument = (id) => {
  return api.get(`api/documents/${id}`);
};

export const download = (documentFile) => {
  const byteChars = atob(documentFile.content);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  let blob = new Blob([byteArray], {
    type: documentFile.contentType,
  });
  let link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = documentFile.filename;
  link.click();
};
